export const CHAT_TABLE_TITLE_NODE_NAME = 'chatTableTitle';
export const CHAT_TABLE_WRAPPER_NODE_NAME = 'chatTableWrapper';

export const CHAT_TABLE_TITLE_DATA_ATTRIBUTE = 'data-chat-input-table-title';
export const CHAT_TABLE_WRAPPER_DATA_ATTRIBUTE = 'data-chat-input-table-wrapper';
